import { call, put, select } from 'redux-saga/effects';

import { requestFailed } from '../../app/actions/RequestFailedAction';
import { ServiceLocator } from '../../app/ServiceLocator';
import { Messages } from '../../codegen/Localize';
import { ContentActions } from '../../ts/services/ContentActions';
import { EditPublishedConnectionReduxAction } from '../actions/EditPublishedConnectionReduxAction';

export function* handleEditPublishedConnection(action: EditPublishedConnectionReduxAction) {
  try {
    ServiceLocator.get<ContentActions>('ContentActions').editPublishedConnection(action.publishedConnection.luid);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}
